import type { ActivatedRouteSnapshot, ViewTransitionInfo } from '@angular/router';

/** The URL path a router state renders, without query params or fragment. */
function pathOf(root: ActivatedRouteSnapshot): string {
  const segments: string[] = [];
  for (let route: ActivatedRouteSnapshot | null = root; route; route = route.firstChild) {
    segments.push(...route.url.map((segment) => segment.path));
  }
  return segments.join('/');
}

/**
 * `withViewTransitions({ onViewTransitionCreated })`: a navigation that changes only the query
 * params — a filter, the week on /locations (#697) — updates the page in place, so it skips the
 * cross-fade that a real page change gets.
 */
export function skipQueryOnlyTransitions({ transition, from, to }: ViewTransitionInfo): void {
  // The router catches the AbortError a skipped transition rejects `ready` with, but logs it with
  // console.error in dev mode ("Transition was skipped"): expected noise, silent in production.
  // The only way to not start the transition is private (`skipNextTransition`).
  if (pathOf(from) === pathOf(to)) transition.skipTransition();
}
